import React from 'react';
import ActualitesMusee from '../components/ActualitesMusee';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';
import { Helmet } from 'react-helmet';

function App() {
  // Define the websiteLogoUrl here or import it from a config file.
  // Make sure this URL is absolute and publicly accessible.
  const websiteLogoUrl = "https://www.museedestroupesdemarine.fr/logo.jpg"; // EXAMPLE: Replace with your actual logo URL

  return (
    <div className="App">
      <Helmet>
        {/* Basic Meta Tags */}
        <title>Musée des Troupes de Marine - Actualités du Musée</title>
        <meta name="description" content="Découvrez les dernières actualités du Musée des Troupes de Marine" />
        <meta name="keywords" content="Musée des Troupes de Marine, histoire militaire, histoire, histoire des troupes de marine, conférences, actualités, patrimoine" />

        {/* Favicons for all browsers and devices */}
        {/* Ensure these files (favicon.ico, apple-touch-icon.png, manifest.json) are in your public folder */}
        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <link rel="manifest" href="/manifest.json" />

        {/* Open Graph (for Facebook, LinkedIn, etc.) */}
        <meta property="og:title" content="Musée des Troupes de Marine - Actualités du Musée" />
        <meta property="og:description" content="Découvrez les dernières actualités du Musée des Troupes de Marine" />
        {/* Important: 'og:image' must be the ABSOLUTE and PUBLIC URL of your image */}
        <meta property="og:image" content={websiteLogoUrl} />
        <meta property="og:url" content="https://www.museedestroupesdemarine.fr/pages/ActualitesMusee" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="fr_FR" />

        {/* Twitter Card (for Twitter) */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Musée des Troupes de Marine - Actualités du Musée" />
        <meta name="twitter:description" content="Découvrez les dernières actualités du Musée des Troupes de Marine." />
        <meta name="twitter:image" content={websiteLogoUrl} />
        {/* <meta name="twitter:site" content="@NomDeTonCompteTwitter" /> If you have a Twitter account for the museum */}
        {/* <meta name="twitter:creator" content="@NomDeTonCompteTwitter" /> For the specific content author */}

        {/* Canonical tags to avoid duplicate content */}
        <link rel="canonical" href="https://www.museedestroupesdemarine.fr/pages/ActualitesMusee" />

        {/* Mobile optimization (often already in index.html, but useful here if you need to override) */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
      </Helmet>
      <ActualitesMusee />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;